export const yodaFavoritesConstants = {
  UPSERT_FAVORITE_REQUEST: "YODAFAVORITES_UPSERT_REQUEST",
  UPSERT_FAVORITE_SUCCESS: "YODAFAVORITES_UPSERT_SUCCESS",
  UPSERT_FAVORITE_FAILURE: "YODAFAVORITES_UPSERT_FAILURE",
};
